// @flow
import styled from "styled-components";

import buildColor from "../../_static/ColorPalette";

export default styled.section`
  width: 100%;
`;

export const EmptyStateContainer = styled.div`
  background: ${buildColor("white", "100")};
  border-radius: 2px;
  padding: 16px 8px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

export const LoginMainWrapper = styled.div`
  background-color: ${buildColor("white", "100")};
  display: flex;
  align-items: center;
  flex-grow: 1;
`;
